import { useGetCustomerContext } from "../queries/useGetCustomerContext";
import { useGetEnterpriseOverview } from "../queries/useGetEnterpriseOverview";
import type { AskReliCustomerChatProps } from "./AskReli.types";
import { ReliAssistantPanel } from "./ReliAssistantPanel";

export function AskReliCustomerChat({
  externalCustomerId,
  contextLabel,
  isExpanded,
  userName,
  onClose,
  onToggleExpand,
}: AskReliCustomerChatProps) {
  const { data: customer } = useGetCustomerContext(externalCustomerId);
  const { data: overview } = useGetEnterpriseOverview(customer.customerId);

  return (
    <ReliAssistantPanel
      chrome="floating"
      customerFacilities={overview.facilities}
      customerSummary={overview.summary}
      contextLabel={contextLabel}
      isExpanded={isExpanded}
      key={customer.customerId}
      customerId={customer.customerId}
      userName={userName}
      onClose={onClose}
      onToggleExpand={onToggleExpand}
    />
  );
}
